export const appendBuildInfo = async() => {
    const jsBuildInfoScript = document.createElement( "script" );

    jsBuildInfoScript.setAttribute( "class", "buildInfo" );
    jsBuildInfoScript.setAttribute( "data-buildinfo", "X.X.X-ef9ab00c" );
    document.getElementsByTagName( "head" )[0].appendChild( jsBuildInfoScript );
};